import React from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import Title from "designs/v1/components/Title";
import Button from "designs/v1/components/Button";
import {
  getRequestTypeStage,
  getRequestTypeDocs,
  createSegmentReasonApi,
  getSegmentStageApi,
} from "designs/v1/pages/ModifyKyc/services";
import { jsonToFormData } from "utils";

const SegmentModificationReason = ({
  stageScreen,
  setStageScreen,
  setStep,
  isContinue,
  setIsContinue,
  isLoading,
  setIsLoading,
}) => {
  const initialValues = {
    reason: "",
  };
  const validationSchema = Yup.object().shape({
    reason: Yup.string().required(),
  });

  const getModifyStage = async () => {
    setIsLoading(true);
    try {
      let payload = {
        request_type: stageScreen,
        doc_name: localStorage.getItem("SegmentRequestNumber"),
      };
      const resp = await getSegmentStageApi(payload);
      let stageList = resp.data?.data?.RekycRequests_flow_status || [];
      let pageName = 0;
      for (let index = 0; index < stageList.length; index++) {
        const element = stageList[index];
        if (pageName === 0) {
          if (element?.changes_in_which_account_data?.status === 0) {
            pageName = "DematUccForm";
          } else if (element?.modification_details?.status === 0) {
            pageName = "SegmentModification";
          } else if (element?.reason?.status === 0) {
            pageName = "SegmentModificationReason";
          } else if (element?.review?.status === 0) {
            pageName = "SegmentModificationReview";
          } else if (
            element?.requested_for__esignature?.status === 0 ||
            element?.requested_for__esignature?.status === 1
          ) {
            pageName = "SegmentModificationESignature";
          }
        }
      }
      console.log("stage", pageName);
      setStep(pageName);
      setIsLoading(false);
    } catch (error) {
      const { data } = error.response || {};
      toast.error(data.message?.message);
      setIsLoading(false);
    }
  };

  const handleSubmit = async (value) => {
    const payload = {
      request_type: stageScreen,
      doc_name: localStorage.getItem("SegmentRequestNumber"),
      ...value,
    };
    console.log("payload", payload);
    setIsLoading(true);
    try {
      const resp = await createSegmentReasonApi(jsonToFormData(payload));
      console.log("resp", resp);
      setIsLoading(false);
      if (resp.data.message?.status_code !== 200) {
        return toast.error(
          resp.data.message?.message || "Internal server error!"
        );
      }
      const requestTypes = getRequestTypeStage();
      const requestTypesDocs = getRequestTypeDocs() || [];
      requestTypesDocs.push(payload.doc_name);
      if (requestTypes && requestTypes.length > 0) {
        requestTypes.shift();
        localStorage.setItem("RequestTypeStage", JSON.stringify(requestTypes));
        localStorage.setItem("RequestTypeDocs", JSON.stringify(requestTypesDocs));
        Swal.fire({
          title: resp.data.message?.message,
          icon: "success",
          showCloseButton: false,
          showConfirmButton: false,
          timer: 3000,
        });
        if (requestTypes.length === 0) {
          setTimeout(async () => {
            await setStageScreen("MultipleRequestTypes");
          }, 3000);
          return;
        }
        setTimeout(async () => {
          await setStageScreen(requestTypes[0]);
        }, 3000);
        return;
      }
      toast.success(resp.data.message?.message);
      getModifyStage();
    } catch (error) {
      const { data } = error.response || {};
      toast.error(data.message?.message || "Internal server error!");
      setIsLoading(false);
    }
  };

  return (
    <>
      <Title title="Reason" />
      <div className="row">
        <div className="col-md-9">
          <div className="form-group">
            <div className="mb-2">
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
              >
                {({ isValid, dirty, isSubmitting }) => (
                  <Form>
                    <div className="form-group my-2">
                      <label className="py-1">Reason (maximum 150 characters):</label>
                      <Field
                        type="text"
                        name="reason"
                        placeholder="Enter your reason here..."
                        className="form-control"
                        as="textarea"
                        maxLength={150}
                        rows={3}
                        autoFocus
                      />
                    </div>
                    <div className="d-flex mt-4">
                      {isContinue && (
                        <div className="">
                          <Button
                            title="Back"
                            type="button"
                            handleClick={() => {
                              setStep("CheckPrevRequest");
                              setIsContinue(false);
                            }}
                            disabled={isLoading}
                          />
                        </div>
                      )}
                      <div className="mx-2">
                        <Button
                          title="Submit"
                          disabled={!isValid || !dirty || isSubmitting || isLoading}
                        />
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SegmentModificationReason;
